export default __webpack_public_path__ + "static/media/pricing-shape.9c1ddbcd.svg";